import React from 'react';
import { useLocalization } from '@/hooks/useLocalization';
import { Button, Stack, useMediaQuery, useTheme } from '@mui/material';
import { AccountHeaderProps } from '../types';
import FlyoutHeader from '../common/FlyoutHeader';

const AccountHeader: React.FC<AccountHeaderProps> = ({
  account,
  onClose,
  onDelete,
  onEdit,
  onMarkAsClosed,
}) => {
  const { t } = useLocalization();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const showActions =
    isMobile &&
    account.CanEdit &&
    typeof onEdit === 'function' &&
    typeof onDelete === 'function' &&
    typeof onMarkAsClosed === 'function';

  return (
    <FlyoutHeader
      title={account.Name}
      subtitle={account.InstitutionName}
      onClose={onClose}
      actions={
        showActions ? (
          <Stack
            direction='row'
            spacing={1}
            flexWrap='wrap'
            useFlexGap
          >
            <Button
              variant='contained'
              color='primary'
              onClick={() => {
                onEdit(account);
              }}
              sx={{
                minWidth: 0,
                textTransform: 'none',
                transition: 'transform 160ms ease, box-shadow 160ms ease',
                '&:hover': {
                  transform: 'translateY(-1px)',
                },
              }}
            >
              {t('edit')}
            </Button>
            <Button
              variant='outlined'
              color='inherit'
              onClick={() => {
                onDelete(account);
              }}
              sx={{
                minWidth: 0,
                transition: 'transform 160ms ease, border-color 160ms ease',
                '&:hover': {
                  transform: 'translateY(-1px)',
                },
              }}
            >
              {t('delete')}
            </Button>
            <Button
              variant='outlined'
              color='inherit'
              onClick={() => {
                onMarkAsClosed(account);
              }}
              sx={{
                minWidth: 0,
                textTransform: 'none',
                transition: 'transform 160ms ease, border-color 160ms ease',
                '&:hover': {
                  transform: 'translateY(-1px)',
                },
              }}
            >
              {t('close')}
            </Button>
          </Stack>
        ) : null
      }
    />
  );
};

export default React.memo(AccountHeader);
